export enum DorisMetricEndPointEnum {
  SalesEndPoint = 'sales/GetSalesMetrics',
  GetTrafficByTypeEndPoint = 'GetTrafficByType',
  SalesExportEndPoint = 'api/atlas/SubmitExportRequest/SalesExportRequest'
}

export enum DorisMetricTypeEnum {
  RetailSales = 'retailSales',
  UnitsSold = 'unitsSold',
  RetailPrice = 'retailPrice',
  TotalClicks = 'totalClicks',
  PromotionSales = 'promotionSales',
  PromotionCount = 'promotionCount',
  PromotionSalesRetailSales = 'promotionSales/retailSales',
  AverageContentScore = 'averageContentScore',
  AverageDiscount = 'averageDiscount',
  ReviewsRating = 'reviewsRating',
  ProductsWithSalesCount = 'productsWithSalesCount',
  ProductsWithSalesData = 'ProductsWithSalesData',
  ProductsWithReviewsData = 'productsWithReviewsData',
  ProductsWithContentScoreData = 'productsWithContentScoreData',
  ProductsWithPromotionSalesData = 'productsWithPromotionSalesData',
  StacklineSkuCount = 'stacklineSkuCount',
  SalesSummary = 'salesSummary',
  SegmentWithSalesSummary = 'SegmentWithSalesSummary',
  Conversion = 'Conversion',
  ProductsWithPromotionDataExport = 'productsWithPromotionDataExport'
}

export enum DorisGroupByFieldNameEnum {
  Retailer = 'retailer',
  Brand = 'brand',
  Category = 'category',
  Subcategory = 'subcategory',
  Segment = 'segment',
  Manufacturer = 'manufacturer',
  Keyword = 'keyword',
  Product = 'product',
  Week = 'week'
}

export enum DorisDropdownFieldNameEnum {
  Traffic = 'traffic',
  Sales = 'sales'
}

export enum DorisTableFieldColumnNamesEnum {
  Rating = 'rating',
  ReviewsCount = 'reviewsCount',
  RetailSales = 'retailSales',
  ReviewsRating = 'reviewsRating',
  ContentScore = 'contentScoreAvg',
  TitleScore = 'titleScoreAvg',
  BulletScore = 'bulletScoreAvg',
  ImageScore = 'imageScoreAvg',
  VideoScore = 'videoScoreAvg',
  AplusScore = 'aplusScoreAvg',
  WeekEnding = 'weekEnding'
}

export enum DorisFieldDisplayNameEnum {
  TotalClicks = 'Total Traffic',
  OrganicClicks = 'Organic Traffic',
  AdClicks = 'Paid Traffic',
  AdSpend = 'Paid Ad Spend',
  KeywordsWithTotalTrafficCount = 'Keywords',
  PurchaseRate = 'Conversion',
  RetailSales = 'Retail Sales',
  PromotionSales = 'Promotion Sales',
  PromotionCount = 'Promotions',
  PromotionSalesRetailSales = 'Promotion Sales/Retail Sales',
  AverageDiscount = 'Average Discount',
  ReviewsRating = 'Rating',
  ProductsWithReviewsData = 'Products with Reviews Data',
  ProductsWithContentScoreData = 'Products with Content Score Data',
  ProductsWithPromotionSalesData = 'Products with Promotion Sales Data',
  RetailPrice = 'Retail Price',
  ContentScore = 'Content Score',
  UnitsSold = 'Units Sold',
  RetailSalesMarketShareV2 = 'Share ($)',
  UnitsSoldMarketShareV2 = 'Share (UNITS)',
  StacklineSkuCount = 'Products'
}
